import template from './activityIcon.html';

export default {
  template,
  bindings: {
    type: '<',
  },
  controllerAs: 'vm',
};
